export default __webpack_public_path__ + "static/media/ic-care-support.b134a116.svg";